module.exports = __webpack_public_path__ + "static/media/boilmaker.e01d46d1.svg";